export const translations = {
  en: {
    // EmergencyHeader
    heroTitle: '24/7 Towing &',
    heroTitleHighlight: 'Car Rental',
    heroTitleSuffix: 'in Georgia',
    heroSubtitle: 'Fast Response. Reliable Service. One Call Away.',
    heroCTA: 'CALL A TOW TRUCK NOW',

    // CarRental
    rentalTitle: 'Rent the Vehicle You Need Today',
    sedan: 'Economy Sedan',
    sedanDesc:
      'Affordable daily rates. Perfect for quick trips and city driving.',
    suv: 'Family SUV',
    suvDesc:
      'Spacious & comfortable. Ideal for family road trips and extra luggage.',
    truck: 'Work Pickup Truck',
    truckDesc:
      'Heavy duty available. Built for tough jobs and moving large items.',
    whatsappCTA: 'CHECK AVAILABILITY ON WHATSAPP',

    // TrustBadges
    fastResponse: 'Fast Response',
    fastResponseDesc: 'We reach you in minutes, not hours',
    insured: 'Fully Insured',
    insuredDesc: 'Complete peace of mind every mile',
    coverage: 'Georgia Wide Coverage',
    coverageDesc: 'Serving Atlanta, Duluth, Braselton & more',

    // SocialProof
    socialTitle: 'Trusted by Georgians Drivers',

    // FinalCTA
    ctaTitle1: 'Stuck on the Road?',
    ctaTitle2: "We're Already on Our Way.",
    ctaSubtitle: 'Available 24 hours, 7 days a week, 365 days a year.',
    ctaTowing: 'CALL NOW - TOWING',
    ctaRent: 'RENT A CAR TODAY',

    // Footer
    contactUs: 'Contact Us',
    whatsappUs: 'WhatsApp Us',
    openHours: 'Open 24/7 - Every Day',
    serviceArea: 'Service Area',
    serviceAreaDesc: 'Auburn, Georgia — Serving all of Georgia',
    copyright: '© 2025 OJ Auto Group LLC - All Rights Reserved',

    // FloatingPhone
    callNowLabel: 'Call Now',
  },
  es: {
    // EmergencyHeader
    heroTitle: 'Grúa y Alquiler de',
    heroTitleHighlight: 'Autos 24/7',
    heroTitleSuffix: 'en Georgia',
    heroSubtitle: 'Respuesta Rápida. Servicio Confiable. A Una Llamada.',
    heroCTA: 'LLAMA A UNA GRÚA AHORA',

    // CarRental
    rentalTitle: 'Alquila el Vehículo que Necesitas Hoy',
    sedan: 'Sedán Económico',
    sedanDesc:
      'Tarifas diarias accesibles. Perfecto para viajes rápidos y conducción en la ciudad.',
    suv: 'SUV Familiar',
    suvDesc:
      'Espacioso y cómodo. Ideal para viajes familiares y equipaje extra.',
    truck: 'Camioneta de Trabajo',
    truckDesc:
      'Servicio pesado disponible. Hecha para trabajos duros y mover artículos grandes.',
    whatsappCTA: 'CONSULTA DISPONIBILIDAD POR WHATSAPP',

    // TrustBadges
    fastResponse: 'Respuesta Rápida',
    fastResponseDesc: 'Llegamos en minutos, no horas',
    insured: 'Totalmente Asegurado',
    insuredDesc: 'Tranquilidad total en cada milla',
    coverage: 'Cobertura en Todo Georgia',
    coverageDesc: 'Sirviendo Atlanta, Duluth, Braselton y más',

    // SocialProof
    socialTitle: 'Confianza de los Conductores de Georgia',

    // FinalCTA
    ctaTitle1: '¿Varado en la Carretera?',
    ctaTitle2: 'Ya Estamos en Camino.',
    ctaSubtitle: 'Disponible 24 horas, 7 días a la semana, 365 días al año.',
    ctaTowing: 'LLAMA AHORA - GRÚA',
    ctaRent: 'ALQUILA UN AUTO HOY',

    // Footer
    contactUs: 'Contáctanos',
    whatsappUs: 'Escríbenos por WhatsApp',
    openHours: 'Abierto 24/7 - Todos los Días',
    serviceArea: 'Área de Servicio',
    serviceAreaDesc: 'Auburn, Georgia — Sirviendo todo Georgia',
    copyright: '© 2025 OJ Auto Group LLC - Todos los Derechos Reservados',

    // FloatingPhone
    callNowLabel: 'Llama Ahora',
  },
}
